import HeaderMessage from "../components/home/HeaderMessage";
import Header from "../components/common/Header";
import Footer from "../layouts/Footer"
import BannerImg from "../images/leave-behind-banner.jpg";
import { useEffect } from "react";
import { RightArrowButton } from "../icons";


const LeaveBehind = () => {

    useEffect(() => {
        // Load Media.net script dynamically
        const script = document.createElement("script");
        script.src = "https://contextual.media.net/dmedianet.js?cid=8CUM72648";
        script.async = true;
        document.body.appendChild(script);

        window._mNHandle = window._mNHandle || {};
        window._mNHandle.queue = window._mNHandle.queue || [];
        window.medianet_versionId = "3121199";

        try {
            window._mNHandle.queue.push(function () {
                window._mNDetails.loadTag("927418270", "600x250", "927418270");
            });
        } catch (error) {
            console.error("Error loading Media.net ad:", error);
        }

        try {
            window._mNHandle.queue.push(function () {
                window._mNDetails.loadTag("855244157", "600x280", "855244157");
            });
        }
        catch (error) {
        }

    }, [])

    const onClickHandler = () => {
        const urlParams = new URLSearchParams(window.location.search);
        window.location.href = `https://eddy.collegenroll.com/search/14/&q=degreeprograms_lb&${urlParams.toString()}`;
    }

    return (
        <div className={`min-h-full flex flex-col`}>
            <div className="flex-1">
                <div className="main-wrapper">
                    <HeaderMessage />
                    <Header />
                    <section className="banner relative pt-12 md:pt-16 pb-[60px] md:pb-32">
                        <img
                            src={BannerImg}
                            alt="Next Step Goals"
                            className="w-full h-full absolute top-0 left-0 object-cover"
                        />
                        <div className="container max-w-[752px] px-4 mx-auto relative z-10">
                            <div className="content px-4 py-5 md:px-10 md:py-9 text-center bg-white rounded-[20px]">
                                <h1 className="font-lexendSemibold text-2xl md:text-4xl text-secondary-500 font-semibold leading-9 md:leading-[48px] mb-4">Ready to Take the Next Step Toward Your Goals?</h1>
                                <p className="text-base md:text-lg text-secondary-400 mb-6 md:mb-8">You’re just one step away from exploring a wide range of programs designed to fit your schedule, goals, and aspirations. Whether you're starting your education journey or planning to level up your career, we’ve got you covered.</p>
                                <div className="flex justify-center items-center max-w-[190px] mx-auto p-4 bg-primary-500 hover:bg-[#e67500] rounded cursor-pointer" onClick={onClickHandler}>
                                    <span className="text mr-2 font-lexendSemibold text-xl leading-5 text-white font-semibold">Start Now</span>
                                    <span className="icon">
                                        <RightArrowButton />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="section py-8 md:pt-8 md:pb-12">
                        <div className="container max-w-[1092px] px-4 mx-auto">
                            <div className="content">

                                <div className="mb-6">
                                    <h3 className="relative pb-[18px] mb-[18px] font-lexendSemibold text-xl md:text-2xl leading-normal text-secondary-500 font-semibold border-b border-light-600">
                                        Comparing Online Colleges:
                                    </h3>
                                    <ol className="list-decimal list-inside marker:font-lexendSemibold marker:text-lg marker:leading-[30px] marker:text-secondary-500 marker:font-semibold">
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Accreditation:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Make sure that the online colleges you’re considering are accredited by a recognized accrediting body. Accreditation implies that the
                                                online college in question meets certain educational standards. An accredited online degree puts you in a better position to secure the
                                                jobs you want.
                                            </p>
                                        </li>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Program Offerings:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Go through the programs and courses offered by the online colleges you’re considering. Search for programs that suit your academic and
                                                career goals. Most universities have comprehensive catalogs for their online degrees. This can make it easier for you to find programs
                                                that match your preferences.
                                            </p>
                                        </li>
                                        <div id="927418270" className="mx-auto mb-6">

                                        </div>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Flexibility and Format:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Online education offers flexibility, but each college may offer different formats. Some offer self-paced learning, while others have
                                                structured schedules. The online college you choose should offer classes in a format that matches your preferred learning style and fits
                                                well with your personal schedule. Convenience is one of the biggest advantages of online learning, so make the most of it.
                                            </p>
                                        </li>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Technology and Support:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Try to gauge the quality of the online learning platform and the technical support provided by the online schools on your list. A
                                                user-friendly interface, access to course materials, and responsive technical assistance contribute to a positive learning experience.
                                            </p>
                                        </li>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Interaction and Engagement:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Many assume that online degrees always involve isolated study. This may have been the case years ago, but today, online programs are
                                                very interactive. Many online colleges use discussion boards, virtual classrooms, collaborative projects, and more to foster engagement
                                                and networking. Look at the tools and methods used by various online colleges to get a better sense of the level of engagement involved.
                                            </p>
                                        </li>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Resources and Libraries:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Access to online libraries, research materials, and academic resources can be immensely helpful - during projects, assignments, or even
                                                if you simply want to learn more about certain topics. Many online colleges provide comprehensive resources to support your studies.
                                                Make sure that the one you choose does the same.
                                            </p>
                                        </li>
                                        <li className="mb-6 last:mb-0">
                                            <h4 className="inline font-lexendSemibold text-lg leading-[30px] text-secondary-500 font-semibold">Cost and Financial Aid:</h4>
                                            <p className="pt-2 font-lexendlight text-base leading-[26px] text-dark-500">
                                                Compare tuition, additional fees, and any other costs, specifically for your desired programs. Don’t forget to check the availability of
                                                financial aid or scholarships! Financial aid can be a significant advantage if you’re eligible. To graduate with the least amount of
                                                stress (not to mention debt), make sure that the college and program you choose fit within your budget. Besides this, many online
                                                colleges also offer flexible payment options to make your higher education more accessible.
                                            </p>
                                        </li>
                                    </ol>
                                </div>

                                <div id="855244157" className="mx-auto">

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className="page-cls-1">
                <Footer />
            </div>
        </div>
    )

}


export default LeaveBehind;